<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="passwordForm">
		<!-- ROW * -->
		<div class="grid">
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Password, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Password, 'label')">{{ 'INSERT_PASSWORD' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Password, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="settings-password"
							formControlName="Password" autocomplete="mtma-contact-add-input-name"
							placeholder="{{ 'PASSWORD' | translate }}" [maxlength]="lengthPassword" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Password)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}. {{ 'AUTOMATION_PASSWORD_NUMBER' | translate }}</small>
			</div>
		</div>

		<div class="grid mt-8 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>